import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  searchProducts(searchCriteria: { searchQuery: string; }) {
    throw new Error("Method not implemented.");
  }

  private searchSource = new BehaviorSubject('');
  private profileSource = new BehaviorSubject('me');
  currentMessage = this.searchSource.asObservable();
  currentProfile = this.profileSource.asObservable();
  constructor() { }

  changeSearch(text: string) {
    this.searchSource.next(text);
  }

  changeProfile(data: any) {
    this.profileSource.next(data);
  }
}
